var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-area"},[_vm._v("\n  "+_vm._s(_vm.data)+"\n  "),_c('base-slider',{attrs:{"label":"0 = não gostei, 10 = gostei"},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }